/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var StateTag = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
  RESOLVED: 'resolved',
  REVISION: 'revision',
  EDIT: 'edit',
  MANUAL_REVIEW: 'manual_review',
  PENDING_PROCESS: 'pending_process',
  COLLECTION_FLOW: 'collection_flow',
  FAILURE: 'failure',
  DATA_ENRICHMENT: 'data_enrichment',
  FLAGGED: 'flagged',
  DISMISSED: 'dismissed'
};
var StateTags = [StateTag.APPROVED, StateTag.REJECTED, StateTag.RESOLVED, StateTag.REVISION, StateTag.EDIT, StateTag.MANUAL_REVIEW, StateTag.PENDING_PROCESS, StateTag.COLLECTION_FLOW, StateTag.FAILURE, StateTag.DATA_ENRICHMENT, StateTag.FLAGGED, StateTag.DISMISSED];
var CommonWorkflowEvent = {
  START: 'START',
  CASE_REVIEWED: 'CASE_REVIEWED',
  RETURN_TO_REVIEW: 'RETURN_TO_REVIEW',
  RESUBMITTED: 'RESUBMITTED',
  REJECT: 'reject',
  APPROVE: 'approve',
  REVISION: 'revision',
  RESOLVE: 'resolve',
  FLAG: 'flag',
  DISMISS: 'dismiss',
  EDIT: 'edit'
};
var CommonWorkflowStates = {
  IDLE: 'idle',
  MANUAL_REVIEW: 'manual_review',
  REJECTED: 'rejected',
  APPROVED: 'approved',
  RESOLVED: 'resolved',
  REVISION: 'revision',
  FLAGGED: 'flagged',
  DISMISSED: 'dismissed'
};
var WorkflowDefinitionVariant = {
  WEBSITE_MONITORING: 'WEBSITE_MONITORING',
  MANUAL_REVIEW: 'MANUAL_REVIEW',
  KYB: 'KYB',
  KYB_WITH_ASSOCIATED_COMPANIES: 'KYB_WITH_ASSOCIATED_COMPANIES',
  KYC: 'KYC',
  DEFAULT: 'DEFAULT',
  ONGOING: 'ONGOING',
  AML: 'AML'
};
var ProcessStatus = {
  DEFAULT: 'DEFAULT',
  IDLE: 'IDLE',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  CANCELED: 'CANCELED'
};
var ProcessStatuses = [ProcessStatus.IDLE, ProcessStatus.IN_PROGRESS, ProcessStatus.SUCCESS, ProcessStatus.ERROR, ProcessStatus.CANCELED];
var UnifiedApiReason = {
  NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
  NOT_AVAILABLE: 'NOT_AVAILABLE'
};
var UnifiedApiReasons = [UnifiedApiReason.NOT_IMPLEMENTED, UnifiedApiReason.NOT_AVAILABLE];
var WorkflowDefinitionConfigThemeEnum = {
  KYC: 'kyc',
  KYB: 'kyb',
  DOCUMENTS_REVIEW: 'documents-review'
};
var WorkflowDefinitionConfigThemes = [WorkflowDefinitionConfigThemeEnum.KYB, WorkflowDefinitionConfigThemeEnum.KYC, WorkflowDefinitionConfigThemeEnum.DOCUMENTS_REVIEW];
var Severity = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low'
};
var Severities = [Severity.CRITICAL, Severity.HIGH, Severity.MEDIUM, Severity.LOW];
var MatchResponseCode = {
  M00: 'M00',
  M01: 'M01',
  M02: 'M02'
};
var MatchResponseCodes = [MatchResponseCode.M00, MatchResponseCode.M01, MatchResponseCode.M02];
var MatchReasonCode = {
  '00': 'Questionable Merchant/Under Investigation',
  '01': 'Account Data Compromise',
  '02': 'Common Point of Purchase (CPP)',
  '03': 'Laundering',
  '04': 'Excessive Chargebacks',
  '05': 'Excessive Fraud',
  '06': 'Reserved for Future Use',
  '08': 'Mastercard Questionable Merchant Audit Program',
  '09': 'Bankruptcy/Liquidation/Insolvency',
  '10': 'Violation of Standards',
  '11': 'Merchant Collusion',
  '12': 'PCI Data Security Standard Noncompliance',
  '13': 'Illegal Transactions',
  '14': 'Identity Theft',
  '20': 'Mastercard Questionable Merchant Audit Program',
  '21': 'Listing under Privacy Review',
  '24': 'Illegal Transactions'
};
var URL_PATTERN = /^(?:https?:\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00A1-\uFFFF][a-z0-9\u00A1-\uFFFF_-]{0,62})?[a-z0-9\u00A1-\uFFFF]\.)+(?:[a-z\u00A1-\uFFFF]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
var CHECKS_STATUSES = ['in-progress', 'failed', 'completed'];
var CHECKS_STATUSES_MAP = Object.fromEntries(CHECKS_STATUSES.map(function (status) {
  return [status, status];
}));
var ASSESSMENT_STATUSES = ['in-progress', 'pending-review', 'under-review', 'approved', 'rejected'];
var ASSESSMENT_STATUSES_MAP = Object.fromEntries(ASSESSMENT_STATUSES.map(function (status) {
  return [status, status];
}));
var UPDATEABLE_ASSESSMENT_STATUSES = [ASSESSMENT_STATUSES_MAP['pending-review'], ASSESSMENT_STATUSES_MAP['under-review'], ASSESSMENT_STATUSES_MAP['approved'], ASSESSMENT_STATUSES_MAP['rejected']];
var MERCHANT_REPORT_STATUSES = ['in-progress', 'quality-control', 'pending-review', 'under-review', 'failed', 'completed', 'cleared', 'conditionally-approved', 'terminated'];
var MERCHANT_REPORT_STATUSES_MAP = Object.fromEntries(MERCHANT_REPORT_STATUSES.map(function (status) {
  return [status, status];
}));
var UPDATEABLE_REPORT_STATUSES = [MERCHANT_REPORT_STATUSES_MAP['pending-review'], MERCHANT_REPORT_STATUSES_MAP['under-review'], MERCHANT_REPORT_STATUSES_MAP['completed'], MERCHANT_REPORT_STATUSES_MAP['cleared'], MERCHANT_REPORT_STATUSES_MAP['conditionally-approved'], MERCHANT_REPORT_STATUSES_MAP['terminated']];
var MERCHANT_REPORT_TYPES = ['MERCHANT_REPORT_T1', 'ONGOING_MERCHANT_REPORT_T1'];
var MERCHANT_REPORT_TYPES_MAP = Object.fromEntries(MERCHANT_REPORT_TYPES.map(function (type) {
  return [type, type];
}));
var MERCHANT_REPORT_VERSIONS = ['1', '2', '3'];
var MERCHANT_REPORT_VERSIONS_MAP = Object.fromEntries(MERCHANT_REPORT_VERSIONS.map(function (version) {
  return [version, version];
}));
var MERCHANT_REPORT_RISK_LEVELS = ['low', 'medium', 'high', 'critical'];
var MERCHANT_REPORT_RISK_LEVELS_MAP = Object.fromEntries(MERCHANT_REPORT_RISK_LEVELS.map(function (level) {
  return [level, level];
}));
var RISK_INDICATOR_RISK_LEVELS = ['positive', 'moderate', 'critical'];
var RISK_INDICATOR_RISK_LEVELS_MAP = Object.fromEntries(RISK_INDICATOR_RISK_LEVELS.map(function (level) {
  return [level, level];
}));
var SUPPORTED_FILE_EXT_REGEX = /\.(jpg|jpeg|svg|png|pdf|gif|txt|csv|xlsx|xls)$/;

// Extract file extensions from regex
var SUPPORTED_FILE_EXT_ENUM = {
  JPG: 'jpg',
  JPEG: 'jpeg',
  SVG: 'svg',
  PNG: 'png',
  PDF: 'pdf',
  GIF: 'gif',
  TXT: 'txt',
  CSV: 'csv',
  XLSX: 'xlsx',
  XLS: 'xls'
};

// validate file exts in enum against regex
Object.entries(SUPPORTED_FILE_EXT_ENUM).forEach(function (_ref) {
  _ref[0];
    var value = _ref[1];
  if (!SUPPORTED_FILE_EXT_REGEX.test("." + value)) {
    throw new Error("Invalid file extension: ." + value);
  }
});
var BANK_ACCOUNT_VERIFICATION_COMMERCIAL_REQUEST_TYPE = 'BAVCommercial-Standard';

export { ASSESSMENT_STATUSES, ASSESSMENT_STATUSES_MAP, BANK_ACCOUNT_VERIFICATION_COMMERCIAL_REQUEST_TYPE, CHECKS_STATUSES, CHECKS_STATUSES_MAP, CommonWorkflowEvent, CommonWorkflowStates, MERCHANT_REPORT_RISK_LEVELS, MERCHANT_REPORT_RISK_LEVELS_MAP, MERCHANT_REPORT_STATUSES, MERCHANT_REPORT_STATUSES_MAP, MERCHANT_REPORT_TYPES, MERCHANT_REPORT_TYPES_MAP, MERCHANT_REPORT_VERSIONS, MERCHANT_REPORT_VERSIONS_MAP, MatchReasonCode, MatchResponseCode, MatchResponseCodes, ProcessStatus, ProcessStatuses, RISK_INDICATOR_RISK_LEVELS, RISK_INDICATOR_RISK_LEVELS_MAP, SUPPORTED_FILE_EXT_ENUM, SUPPORTED_FILE_EXT_REGEX, Severities, Severity, StateTag, StateTags, UPDATEABLE_ASSESSMENT_STATUSES, UPDATEABLE_REPORT_STATUSES, URL_PATTERN, UnifiedApiReason, UnifiedApiReasons, WorkflowDefinitionConfigThemeEnum, WorkflowDefinitionConfigThemes, WorkflowDefinitionVariant };
//# sourceMappingURL=index.js.map
